import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';
import { Sidebar } from '@futrli/ui-components';

import { useConsolidationContext } from '../../../consolidation-context/consolidation-context';
import { EditDailyFxRatesForm } from './edit-daily-fx-rates-form/edit-daily-fx-rates-form';
import styles from './edit-daily-fx-rates-modal.scss';

export const EditDailyFxRatesSidebar = () => {
  const [showOverlapError, setShowOverlapError] = useState(false);
  const intl = useIntl();

  const {
    dailyFxRates: {
      fxRatesOverrideForm,
      handleCancelFxRatesOverrideModal,
      handleSaveFxRateOverrides,
      selectedFXCurrencyCode,
      showFxRatesOverrideModal
    }
  } = useConsolidationContext();

  const handleSubmit = useCallback(() => {
    if (!fxRatesOverrideForm.checkForOverlappingDateRanges()) {
      setShowOverlapError(false);
      handleSaveFxRateOverrides();
    } else {
      setShowOverlapError(true);
    }
  }, [fxRatesOverrideForm, handleSaveFxRateOverrides]);

  useEffect(() => {
    setShowOverlapError(false);
  }, [showFxRatesOverrideModal]);

  return (
    <Sidebar
      open={showFxRatesOverrideModal}
      onCancel={handleCancelFxRatesOverrideModal}
      header={
        <Typography variant="h2" fontWeight="700">
          {intl.formatMessage({ id: 'consolidation.edit_daily_fx_rates', defaultMessage: 'Edit daily FX rates' })}
        </Typography>
      }
      size="extra-large"
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleCancelFxRatesOverrideModal}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button onClick={handleSubmit} disabled={!fxRatesOverrideForm.formState.isValid} buttonType="primary">
            <FormattedMessage id="common.save" defaultMessage="Save" />
          </Button>
        }
        onSubmit={handleSubmit}
      >
        <p className={styles.text}>
          <FormattedMessage
            id="consolidation.control_modal_description"
            defaultMessage="This is the control modal for editing FX rates for: {currencyCode}"
            values={{ currencyCode: selectedFXCurrencyCode }}
          />
        </p>
        <EditDailyFxRatesForm />
        <div style={{ marginTop: '16px' }}>
          {showOverlapError && (
            <Typography color="errorRed" fontSize="16px" fontWeight="500">
              <FormattedMessage
                id="consolidation.overrides_must_not_have_overlapping_dates"
                defaultMessage="Overrides must not have overlapping date ranges"
              />
            </Typography>
          )}
        </div>
      </Form>
    </Sidebar>
  );
};
